var RichTextEditor = {
	richTextEditor: "Rich text editor",
	imageSizeOptions: {
		wallpaper1024: "Wallpaper (1024px)",
		wallpaper2048: "Wallpaper (2048px)",
		original: "Original size",
		inline: "Inline (16px)",
		icon: "Icon (32px)",
		thumb: "Thumbnail (50px)",
		smallLogo: "Small logo (100px)",
		logo: "Logo (160px)",
		productThumb: "Product thumbnail (240px)",
		productImage: "Product image (480px)",
		bannerImage: "Banner image (600px)"
	},
	alignments: {
		left: "Left align",
		center: "Center align",
		right: "Right align"
	},
	editImage: "Edit image",
	cancel: "Cancel",
	altTextLabel: "Image alt text",
	altTextHelpText: "Alt text makes images more accessible to everyone, including people with visual impairments. Learn more about {altTextLink}.",
	altText: "alt text",
	insertImage: "Insert image",
	insertVideo: "Insert video",
	insertLink: "Insert link",
	editLink: "Edit link",
	removeLink: "Remove link"
};
var _en = {
	RichTextEditor: RichTextEditor
};

export { RichTextEditor, _en as default };
